import { render } from "./BikeGarageApp.vue?vue&type=template&id=deda9e86&scoped=true"
import script from "./BikeGarageApp.vue?vue&type=script&lang=js"
export * from "./BikeGarageApp.vue?vue&type=script&lang=js"

import "./BikeGarageApp.vue?vue&type=style&index=0&id=deda9e86&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deda9e86"]])

export default __exports__